import { Component, Input, Output, EventEmitter, OnInit } from '@angular/core';
import { RequestLog } from '@shared-features/models/request-log.model';
import { SafeUrl } from '@angular/platform-browser';
import { CreatedByType } from '@shared/enums/created-by-type.enum';
import { maskSensitiveData } from '@shared/utils/mask-log-b2c.util';

@Component({
  selector: 'app-request-and-response-log',
  templateUrl: './request-and-response-log.component.html',
  styleUrls: ['./request-and-response-log.component.scss'],
})
export class RequestAndResponseLogComponent implements OnInit {
  @Input() selectedItem: RequestLog & { label: string } = null;
  @Input() selectedItemPayload: string = null;
  @Input() maskData = false;

  @Output() closeModal = new EventEmitter();
  downloadString: SafeUrl;
  creatorType = CreatedByType;

  constructor() {}

  ngOnInit(): void {
    if (this.maskData) {
      this.selectedItemPayload = maskSensitiveData(this.selectedItemPayload);
    }
  }
}
